<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Product Licences</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:w-full">
                        <div class="account-body">
                            <div class="results-list">
                                <div class="results-row">
                                    <div class="results-head" data-width="40%">Product</div>
                                    <div class="results-head" data-width="20%">Expires</div>
                                    <div class="results-head" data-width="20%">Identifier</div>
                                    <div class="results-head" data-width="20%">Active</div>
                                </div>
                                <template v-if="licences">
                                    <div class="results-row" v-for="(licence, index) in licences" :key="index"
                                         @click="handleViewLicence(licence)">
                                        <div class="results-cell" data-width="40%">{{ licence.product }}</div>
                                        <div class="results-cell" data-width="20%">{{
                                                formatDateShort(licence.expires)
                                            }}
                                        </div>
                                        <div class="results-cell" data-width="20%">{{ licence.identifier }}</div>
                                        <div class="results-cell" data-width="20%">{{
                                                licence.active ? 'Yes' : 'No'
                                            }}
                                        </div>
                                    </div>
                                </template>
                                <div class="results-row" v-if="licences && licences.length === 0">
                                    <div class="results-span text-center" data-width="100%">
                                        <p>No results found</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">
                        <button class="btn-primary muted" type="button" @click="handleAddLicence">Add Licence</button>
                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>
            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductLicencesList',
    components: {
        //
    },
    props: {
        //
    },
    data() {
        return {
            licences: null,
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.loadData()
        next()
    },
    mounted() {
        this.loadData()

        this.setMetaTitle('Product Licences | JournoLink Control')
    },
    methods: {
        loadData() {
            axios.get(route('productlicences.list', {user_id: this.$route.params.userId}))
                .then(response => {
                    this.licences = response.data.data
                })
                .catch(e => {
                    console.error({e})
                })
        },
        /**
         * Handle a click event to view a licence
         *
         * @param  {Object} licence
         * @return {void}
         */
        handleViewLicence(licence) {
            this.$router.push({
                name: 'users.productlicences.show', params: {
                    userId: this.$route.params.userId,
                    licenceId: licence.id,
                }
            })
        },
        /**
         * Handle a click event to add a new licence.
         *
         * @return {void}
         */
        handleAddLicence() {
            this.$router.push({name: 'users.productlicences.create', params: {userId: this.$route.params.userId}})
        },
        /**
         * Format the given date for output.
         *
         * @param  {String} date
         * @return {String}
         */
        formatDateShort(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
    },
    computed: {
        //
    },
}
</script>
